<div class="layout-wrapper">
  <app-accessibility-header></app-accessibility-header>
  <app-ias-header></app-ias-header>
  <router-outlet></router-outlet>
  <app-ias-footer></app-ias-footer>
</div>
